<div class="py-16 mb-8 px-container">

    <div class="flex lg:flex-row flex-col justify-between lg:items-center flex-wrap-reverse gap-8">
        <h1 class="text-3xl md:text-5xl lg:text-6xl mb-0">{{carnet_info?.titolo}}</h1>
        <a class="btn btn-sm btn-primary block md:inline-block !no-underline cursor-pointer text-center" [href]="carnet_info?.link" target="_blank" *ngIf="carnet_info?.link">acquista il carnet</a>
    </div>

    <div [innerHTML]="carnet_info?.descrizione" *ngIf="carnet_info?.descrizione" class="mt-16"></div>

    <div class="carnet-columns mt-16">
        <div *ngFor="let carnet of carnets" class="carnet-columns-item flex flex-col gap-8">
            <article class="lg:pe-8"  *ngFor="let item of carnet.items">
                <div class="left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-full"></div>
                <h1 class="lg:text-4xl text-3xl">{{item.titolo}}</h1>
                <div [innerHTML]="item.descrizione"></div>
            </article>
        </div>
    </div>       
    
</div>